export default __webpack_public_path__ + "static/media/t-shirt.b7daba49.svg";